import React, { useState } from "react";
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
    ReferenceLine,
} from "recharts";

export default function RidesEarningChart() {
    const [period, setPeriod] = useState("Month");

    const dataSets = {
        Day: [
            { name: "Mon", earning: 180 },
            { name: "Tue", earning: 300 },
            { name: "Wed", earning: 250 },
            { name: "Thu", earning: 400 },
            { name: "Fri", earning: 350 },
            { name: "Sat", earning: 270 },
            { name: "Sun", earning: 200 },
        ],
        Week: [
            { name: "Week 1", earning: 1000 },
            { name: "Week 2", earning: 1400 },
            { name: "Week 3", earning: 800 },
            { name: "Week 4", earning: 1300 },
        ],
        Month: [
            { name: "Jan", earning: 1500 },
            { name: "Feb", earning: 2800 },
            { name: "Mar", earning: 900 },
            { name: "Apr", earning: 2200 },
            { name: "May", earning: 3500 },
            { name: "Jun", earning: 1200 },
            { name: "Jul", earning: 3100 },
            { name: "Aug", earning: 2600 },
            { name: "Sep", earning: 900 },
            { name: "Oct", earning: 3700 },
            { name: "Nov", earning: 1900 },
            { name: "Dec", earning: 2100 },
        ],
        Year: [
            { name: "2020", earning: 22000 },
            { name: "2021", earning: 29000 },
            { name: "2022", earning: 25000 },
            { name: "2023", earning: 36000 },
            { name: "2024", earning: 34000 },
        ],
    };

    const data = dataSets[period];
    const totalEarning = data
        .reduce((acc, cur) => acc + cur.earning, 0)
        .toLocaleString();

    const tabContainerStyle = {
        display: "flex",
        alignItems: "center",
        background: "#f8f8ff",
        padding: "6px",
        borderRadius: "8px",
        gap: "4px",
    };

    const pillStyle = (active) => ({
        padding: "6px 12px",
        borderRadius: "8px",
        cursor: "pointer",
        background: active ? "#0064CF" : "transparent",
        color: active ? "#fff" : "#9291A5",
        border: "none",
        fontSize: "14px",
        fontWeight: 500,
        transition: "all 0.2s ease",
    });

    return (
        <div className="w-100 p-4">
            <div
                className="w-100 rounded-2 border p-3"
                style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    marginBottom: 8,
                }}
            >
                <div className="w-100 d-flex justify-content-between align-items-center mb-3">
                    <div>
                        <h6 className="text-muted mb-1 fs-5">Total Earning</h6>
                        <h4 className="fw-bold fs-2">{totalEarning}</h4>
                    </div>

                    <div style={tabContainerStyle}>
                        {["Day", "Week", "Month", "Year"].map((label) => (
                            <button
                                key={label}
                                style={pillStyle(period === label)}
                                onClick={() => setPeriod(label)}
                            >
                                {label}
                            </button>
                        ))}
                    </div>
                </div>

                <ResponsiveContainer width="100%" height={300}>
                    <BarChart
                        data={data}
                        margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
                    >
                        <CartesianGrid strokeDasharray="3 3" vertical={false} />
                        <ReferenceLine
                            y={2400}
                            stroke="#00B0F0"
                            strokeDasharray="3 6"
                            strokeOpacity={0.25}
                        />
                        <XAxis dataKey="name" />
                        <YAxis />
                        <Tooltip />
                        <Bar
                            dataKey="earning"
                            fill="#00B0F0"
                            radius={[6, 6, 0, 0]}
                        />
                    </BarChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
}
